<template>
  <div class="content-editor-block link">
    <el-input v-model="mValue.title" @input="onInput" placeholder="請輸入連結標題"><template slot="prepend">標題</template></el-input>
    <el-input v-model="mValue.url" @input="onInput" placeholder="請輸入連結網址"><template slot="prepend">連結</template></el-input>
    <el-form-item label="在新分頁開啟:" style="text-align: left;margin-bottom:0;">
      <el-switch
        v-model="mValue.isOpenInNewTab"
        active-text="是"
        inactive-text="否"
        inactive-color="red"
      ></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: () => {
        return { title: '', url: '' }
      }
    }
  },
  data: () => {
    return {
      mValue: { title: '', url: '', isOpenInNewTab: false }
    }
  },
  computed: {},
  methods: {
    onInput () {
      this.$emit('input', this.mValue)
    }
  },
  created () {
    this.mValue = this.value
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
